<template>
  <router-link :to="{ name: 'opportunities.overview', params: { 'opportunity_id': opportunity.id }}">
    <div class="row">
      <div class="col-12 col-lg-4 col-xl-4">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Name:</span>
          <span class="strong">{{opportunity.name}}</span><br/>
          <span class="d-inline-block mt-1">{{ opportunity.client.company }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-1">
        <span>{{ opportunity.lead_type }}</span>
      </div>
      <div class="col-6 col-lg-1 col-xl-1">
        <div class="user-avatar">
          <div class="avatar avatar-sm">
            <img alt="member" class="img-circle" v-bind:src="getAvatar(opportunity.user_id)" />
          </div>
        </div>
      </div>
      <div class="col-6 col-lg-2 col-xl-2">
        <p class="text-truncate" v-if="opportunity.created_at">
          <span class="data-label d-lg-none">Date Created:</span>
          {{opportunity.created_at | moment('DD/MM/YYYY')}}
        </p>
        <p v-else>-</p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2">
        <p class="text-truncate" v-if="opportunity.sign_request && opportunity.sign_request.signed_on">
          <span class="data-label d-lg-none">Date Signed:</span>
          {{opportunity.sign_request.signed_on | moment('DD/MM/YYYY')}}
        </p>
        <p v-else>-</p>
      </div>
      <div class="col-6 col-lg-1 col-xl-1">
        <p class="text-truncate" v-if="opportunity.user_story_document && opportunity.user_story_document.costing">
          <span class="data-label d-lg-none">Total:</span>
          <b>${{opportunity.user_story_document ? opportunity.user_story_document.costing.total_ex : null | currency0 }}</b>
        </p>
      </div>
      <div class="col-6 col-lg-1 col-xl-1 text-end">
        <p>
          <span class="data-label d-lg-none">Status:</span>
          <span v-bind:class="getStatusColor(opportunity.status)" class="status">{{ opportunity.status }}</span>
          <span v-if="recentlyViewed" class="small text-muted d-block mt-1 text-nowrap">
            {{ viewedDaysAgo === 0 ? 'today' : viewedDaysAgo === 1 ? '1 day ago' : viewedDaysAgo + ' days ago' }}
          </span>
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>

export default {
  props: {
    opportunity: {
      required: true,
      type: Object
    }
  },

  computed: {
    viewedDaysAgo() {
      if (!this.opportunity.last_viewed_at) {
        return null;
      }

      return moment().diff(moment(this.opportunity.last_viewed_at), 'days');
    },

    recentlyViewed() {
      return this.opportunity.status === 'Viewed'
        && this.viewedDaysAgo !== null
        && this.viewedDaysAgo <= 30;
    },
  },

  methods: {
    getStatusColor(status) {
      switch (status) {
        case 'Draft':
          return "status-mute"
          break;
        case 'Sent':
          return "status-info"
          break;
        case 'Pending Approval':
          return "status-warning"
          break;
        case 'Approved':
          return "status-info"
          break;
        case 'Viewed':
          return "status-primary"
          break;
        case 'Declined':
          return "status-warning"
          break;
        case 'Signed':
          return "status-success"
          break;
        case 'Expired':
          return "status-danger"
          break;
      }
    },

    getAvatar (id) {
      return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
    },
  }
}
</script>
